import { FunctionalRoadClassType } from 'app/models/enums';

export class OpenLRPathAttributes {
  openlrDistanceToNextLRPoint: number;
  openlrLowestFRCToNextLRPoint: FunctionalRoadClassType;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrpathattributes.model.ts